import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class FiscalPrinterRegister {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  fiscalPrinterRegisterCode!: string;
  @Expose()
  @IsString()
  displayRegisterName!: string;
}
